// extracted by mini-css-extract-plugin
export var active = "_ch-7";
export var blink = "_ch-8";
export var dropDownSelector = "_ch-4";
export var dropDownWrapper = "_ch-3";
export var fakeCursor = "_ch-6";
export var fontSizeButton = "_ch-9";
export var formQuillEditor = "_ch-0";
export var pressed = "_ch-a";
export var qlBlank = "_ch-1";
export var textFormattingToolbar = "_ch-2";
export var textToolbarOption = "_ch-5";